module.exports = __webpack_public_path__ + "img/sponsorH15.5e06ccd3.png";